module.exports = __webpack_public_path__ + "static/media/bts_veld_170805_004_small.21c0707b.jpg";